<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. الفلاتر المتقدمة -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 fw-bold text-primary">
          <i class="fas fa-chart-line ms-2"></i> المجموع التكراري (بنين / بنات)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          
          <!-- فلتر الإدارة -->
          <div class="col-md-3">
            <label class="form-label fw-bold">الإدارة / القطاع</label>
            <select v-model="filters.sector" @change="fetchData" class="form-select">
              <option value="">-- الكل --</option>
              <option value="1">إدارة العريش</option>
              <option value="2">إدارة بئر العبد</option>
            </select>
          </div>

          <!-- فلتر المدرسة (يظهر بناءً على الإدارة أو الكل) -->
          <div class="col-md-3">
            <label class="form-label fw-bold">المدرسة</label>
            <select v-model="filters.school_id" class="form-select">
              <option value="">-- كل المدارس --</option>
              <option v-for="s in schoolsList" :key="s.id" :value="s.id">{{ s.school_name }}</option>
            </select>
          </div>

          <div class="col-md-3">
            <button @click="fetchData" class="btn btn-primary w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              عرض التحليل
            </button>
          </div>
          <div class="col-md-3">
             <button @click="printPage" class="btn btn-dark w-100" :disabled="reportData.length === 0">
               <i class="fas fa-print ms-2"></i> طباعة تفصيلية
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. التقرير (الطباعة) -->
    <div id="printMe" v-if="reportData.length > 0">
      
      <!-- ترويسة التقرير -->
      <div class="text-center mb-4 pt-3 border-bottom pb-3 d-none d-print-block">
         <h3 class="fw-bold text-decoration-underline">بيان المجموع التكراري (تصاعدي - بنين/بنات)</h3>
         <div class="mt-2 d-flex justify-content-center gap-3">
             <span class="badge bg-white text-primary border border-primary px-3 fs-6">بنين: {{ stats.boys }}</span>
             <span class="badge bg-white text-danger border border-danger px-3 fs-6">بنات: {{ stats.girls }}</span>
             <span class="badge bg-dark text-white px-3 fs-6">الإجمالي: {{ stats.total }}</span>
         </div>
      </div>

      <!-- جسم التقرير (أعمدة مزدوجة للصفحة) -->
      <!-- column-count: 2 لأن الجدول عريض -->
      <div class="multi-column-container">
          
          <table class="table table-bordered table-sm text-center align-middle mb-0 data-table">
            <thead class="table-dark small">
              <tr>
                <th rowspan="2" class="align-middle bg-dark text-white border-white">الدرجة</th>
                <th colspan="2" class="bg-primary-subtle text-primary border-primary">بنين</th>
                <th colspan="2" class="bg-danger-subtle text-danger border-danger">بنات</th>
                <th colspan="2" class="bg-secondary text-white">الإجمالي</th>
              </tr>
              <tr>
                <!-- بنين -->
                <th class="bg-light text-dark">عدد</th>
                <th class="bg-primary text-white">تكراري</th>
                <!-- بنات -->
                <th class="bg-light text-dark">عدد</th>
                <th class="bg-danger text-white">تكراري</th>
                <!-- إجمالي -->
                <th class="bg-light text-dark">عدد</th>
                <th class="bg-dark text-white">تكراري</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in reportData" :key="row.degree" class="small-row">
                
                <!-- الدرجة -->
                <td class="fw-bold bg-light">{{ row.degree }}</td>
                
                <!-- بنين -->
                <td><span v-if="row.boys.count > 0">{{ row.boys.count }}</span><span v-else class="text-muted">-</span></td>
                <td class="fw-bold text-primary bg-primary-subtle">{{ row.boys.cum }}</td>
                
                <!-- بنات -->
                <td><span v-if="row.girls.count > 0">{{ row.girls.count }}</span><span v-else class="text-muted">-</span></td>
                <td class="fw-bold text-danger bg-danger-subtle">{{ row.girls.cum }}</td>
                
                <!-- الإجمالي -->
                <td class="bg-light fw-bold">{{ row.total.count }}</td>
                <td class="bg-dark text-white fw-bold">{{ row.total.cum }}</td>
              </tr>
            </tbody>
          </table>

      </div>

      <!-- تذييل -->
      <div class="mt-4 pt-3 border-top d-none d-print-block break-avoid">
          <div class="d-flex justify-content-around fw-bold text-center">
              <div>
                  <p class="mb-1 text-muted">رئيس لجنة الإحصاء</p>
                  <p>....................</p>
              </div>
              <div>
                  <p class="mb-1 text-muted">رئيس الكنترول</p>
                  <p>....................</p>
              </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "DetailedCumulativeReport",
  data() {
    return {
      loading: false,
      filters: { sector: '', school_id: '' },
      schoolsList: [],
      reportData: [],
      stats: { boys: 0, girls: 0, total: 0 }
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.get('/admin/cumulative-report_1', { params: this.filters });
        this.reportData = res.data.data;
        this.stats = res.data.final_stats;
        
        // تحديث قائمة المدارس إذا عادت من الباك اند
        if(res.data.schools) {
            this.schoolsList = res.data.schools;
        }
      } catch (e) {
        console.error(e);
        alert("حدث خطأ في الاتصال");
      } finally {
        this.loading = false;
      }
    },
    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.bg-primary-subtle { background-color: #cfe2ff !important; }
.bg-danger-subtle { background-color: #f8d7da !important; }

/* === تقسيم الأعمدة (عمودين فقط لأن الجدول عريض) === */
.multi-column-container {
    column-count: 2; 
    column-gap: 30px;
    column-rule: 2px solid #333; /* خط فاصل واضح */
    width: 100%;
}

.data-table {
    width: 100%;
    break-inside: auto; 
    font-size: 0.9rem;
}

/* تنسيق الصفوف المضغوطة */
.small-row td {
    padding: 2px 4px !important;
}

@media (max-width: 992px) {
    .multi-column-container {
        column-count: 1;
    }
}

/* === تنسيقات الطباعة === */
@media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }

  .multi-column-container {
      column-count: 2 !important; 
      column-gap: 20px;
  }

  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
      font-size: 10pt;
  }

  /* إجبار الألوان على الظهور */
  .bg-primary-subtle { background-color: #e3f2fd !important; -webkit-print-color-adjust: exact; }
  .bg-danger-subtle { background-color: #fce4ec !important; -webkit-print-color-adjust: exact; }
  .bg-dark { background-color: #212529 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
  .text-white { color: #fff !important; }
  
  .break-avoid {
      page-break-inside: avoid;
      column-span: all;
  }
  
  /* تكرار الهيدر غير مدعوم جيداً داخل الأعمدة المتعددة (Columns CSS)
     لذلك نعتمد على أن الصفحة ستسع عمودين طويلين */
}
</style>